import { z } from 'zod';
import { ArtifactSchema } from '../artifact.js';

export const AgentUnsupportedArtifactSchema = z
  .object({
    kind: z.literal('unsupported'),
    id: z.string(),
  })
  .strict();

export const AgentRenderableArtifactSchema = z.union([
  ArtifactSchema,
  AgentUnsupportedArtifactSchema,
]);

export const AgentV2ConversationListItemSchema = z
  .object({
    id: z.string().uuid(),
    title: z.string(),
    summary: z.string().nullable(),
    lastMessageAt: z.string().datetime().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
  })
  .strict();

export const AgentV2ConversationListResponseSchema = z
  .object({
    items: z.array(AgentV2ConversationListItemSchema),
  })
  .strict();

export const AgentV2ConversationMessageSchema = z
  .object({
    id: z.string().uuid(),
    role: z.enum(['user', 'assistant']),
    text: z.string(),
    artifacts: z.array(AgentRenderableArtifactSchema),
    createdAt: z.string().datetime(),
  })
  .strict();

export const AgentV2ConversationDetailSchema = AgentV2ConversationListItemSchema.extend({
  messages: z.array(AgentV2ConversationMessageSchema),
}).strict();

export type AgentUnsupportedArtifact = z.infer<typeof AgentUnsupportedArtifactSchema>;
export type AgentRenderableArtifact = z.infer<typeof AgentRenderableArtifactSchema>;
export type AgentV2ConversationListItem = z.infer<typeof AgentV2ConversationListItemSchema>;
export type AgentV2ConversationListResponse = z.infer<typeof AgentV2ConversationListResponseSchema>;
export type AgentV2ConversationMessage = z.infer<typeof AgentV2ConversationMessageSchema>;
export type AgentV2ConversationDetail = z.infer<typeof AgentV2ConversationDetailSchema>;
